<!--
 * @Description: 
 * @Date: 2025-06-23 14:28:46
 * @LastEditors: function
 * @LastEditTime: 2025-06-30 10:52:00
 * @FilePath: \protal-web\src\App.vue
-->
<template>
  <div id="app">
    <headers v-if="loading && !pathData.includes(routerPath)"></headers>
    <div v-if="loading && !pathData.includes(routerPath)" style="height: 75px"></div>
    <router-view/>
    <customer  v-if="loading  && !pathData.includes(routerPath)" ></customer>
    <footers v-if="loading  && !pathData.includes(routerPath)" :linkData="linkData"></footers>
  </div>
</template>

<script>
import customer from '@/components/customer/index.vue'
import headers from '@/components/header/index.vue'
import footers from '@/components/footers/index.vue'
import {getLinks} from '@/api/home/index'
import qs from 'qs'
export default {

  name: 'App',
  data() {
    return {
      loading: false,
      pathData: ['/middle.html'],
      linkData: {}
    }
  },
  components: {
    customer,
    headers,
    footers,
  },
  computed: {
    routerPath () {
      return this.$route.path
    }
  },
  methods: {
    async getLinkList () {
      const {data} = await getLinks()
      this.linkData = data
    }
  },
  mounted() {
    // redirectUrl
    // 延时一点加载防止中间内容模块没加载出来，导航和底部加载出来了
    const obj = qs.parse(location.search.slice(1))
    if (obj.tk) {
      localStorage.setItem('token', obj.tk)
    }
    setTimeout(() => {
      this.loading = true
      this.getLinkList()
      this.$store.dispatch('InitContact')
      if (obj.tk) {
        this.$store.dispatch('ActionUserInfo')
      }

    },200)

  }
}
</script>

<style lang="less">
@import "assets/style/index.less";

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: #e6e8eb;
}
</style>
